// util/MyColor.js
const MyColor = {
  gray0: '#FFFFFF',
  gray5: '#FAFAFA',
  gray6: '#F9F9F9',
  gray10: '#EEF0F2',
  gray15: '#e2e2e2',
  gray20: '#DADDE1',
  gray30: '#BEBFC5',
  gray40: '#A5AAB0',
  gray50: '#868B92',
  gray60: '#646970',
  gray70: '#46464A',
  gray80: '#414549',
  gray90: '#212427',
  brand5: '#FFFBF9',
  brand10: '#FFF3ED',
  brand20: '#FF9262',
  brand25: '#FF9262',
  brand30: '#FF7F46',
  brand40: '#F76626',
  brand50: '#F76626',
  brand60: '#F04E06',
  blue: '#3C5AD1',
  blue5: '#F4F9FF',
  blue10: '#EFF7FF',
  blue20: '#C0DBF9',
  blue30: '#80BBFF',
  blue40: '#278AF2',
  blue50: '#0073ED',
  blue60: '#1255A1',
  blue80: '#0073ED',
  green5: '#E8F9EC',
  green10: '#E8F9EC',
  green40: '#0BA800',
  green50: '#0D8728',
  green60: '#0D8227',
  green70: '#08671D',
  yellow10: '#FFF9EC',
  yellow30: '#B18B22',
  yellow40: '#FFC31E',
  yellow60: '#C68700',
  red5: '#FFF0EF',
  red10: '#F5BBB9',
  red30: '#E95C57',
  red50: '#E4312B',
  red60: '#D42E29',
  orange5: '#FFFBF9',
  orange10: '#FFF3ED',
  orange25: '#FFBC98',
  orange40: '#FF783C',
  orange50: '#F76626',
  orange60: '#F04E06',

  gray4C4C4C: '#4c4c4c',
  gray2C2C2C: '#2C2C2C',
  gray383838: '#383838',
  grayF9F9FA: '#F9F9FA',
  grayF5F5F5: '#F5F5F5',
  grayF6F6F9: '#F6F6F9',
  grayCFCFCF: '#CFCFCF',
  gray67676A: '#67676A',
  grayD5D5D5: '#D5D5D5',
  gray9C9C9C: '#9C9C9C',
  dimBlack10: 'rgba(0,0,0,0.1)',
  dimBlack25: 'rgba(0,0,0,0.25)',
  grayB1B1B1: '#B1B1B1',
  orangeFFAE8A: '#FFAE8A',
};

export default MyColor;
